import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const Loader = () => (
  <div>...</div>
);

ReactDOM.render(
  <React.StrictMode>
    {/* Router as to be defined one level up in order for useHistory() to work, otherwise you get 'undefined' error */}
    <BrowserRouter>
      <Suspense fallback={<Loader/>}>
        <App/>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
